import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Switch } from "antd";
import { DoubleRightOutlined, DeleteOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { connect, useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import icon from "../../assets/static/images/secciones/contribuyente.png";
import { setLoading } from "./../../redux/Loading/actions";
import { Tabla } from "./../../components/Table/Table";
import ModalRowData from "./ModalRowData/ModalRowData";
import { editContribuyente } from "../../redux/Sections/MisContribuyentes/actions";
import { misContribuyenteService } from "../../_services/misContribuyentes.service";
import AgregarInmueble from "./Inmueble/AgregarInmueble";
import EditarInmueble from "./Inmueble/EditarInmueble";
import { getInmuebles } from "../../redux/Sections/Inmuebles/actions";
import { useHistory } from "react-router-dom";
import { tipoEtapasService } from "../../_services/tipoEtapas.service";
import { grupoEtapasService } from "../../_services/grupoEtapas.service";
import Select from "../Select/Select";
import { emptyOption } from "../../constants";
import { selectErrorStyles, selectStyles } from "../Select/styles";


const EditContribuyente = ({ show, handleClose, contribuyente, reload }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector(e => e.dashboard);
  const history = useHistory();

  const [showAddInmueble, setShowAddInmueble] = useState(false);
  const [showEditInmueble, setShowEditInmueble] = useState(false);

  const [edit, setEdit] = useState(false);
  const [inmueble, setInmueble] = useState("");
  const [inmuebles, setInmuebles] = useState([]);
  const [defaultValues, setDefaultValues] = useState();
  const [currentValues, setCurrentValues] = useState();
  const [grupos, setGrupos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [grupo, setGrupo] = useState("");
  const [tipo, setTipo] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    getData();

    return () => {
      setDefaultValues("");
      setCurrentValues("");
    };

  }, [contribuyente]);


  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  const getGrupos = async () => {
    let response = await grupoEtapasService.getGrupoEtapas();

    if (response?.length) {
      setGrupos(response.map(e => {
        return {
          ...e,
          value: e.id,
          label: e.nombre
        };
      }));
    }
  };

  useEffect(() => {
    getGrupos();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (grupo && grupo.id) {
        dispatch(setLoading(true));

        let response = await tipoEtapasService.getTipoEtapas(grupo.id);

        if (response?.length) {
          setTipos(response.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          }));

          dispatch(setLoading(false));
        }
        else {
          dispatch(setLoading(false));
        }
      }
      else {
        setTipos([]);
      }
    };

    getData();
  }, [grupo]);

  async function getData() {
    dispatch(setLoading(true));
    try {
      let response = await misContribuyenteService.getContribuyente(contribuyente.id);
      if (response) {
        if (response.gp_estado) {
          let grupoEtapas = await grupoEtapasService.getGrupoEtapas();
          grupoEtapas = grupoEtapas.map(e => {
            return {
              ...e,
              value: e.id,
              label: e.nombre
            };
          });

          let tipoEtapas = await tipoEtapasService.getTipoEtapas(response.gp_estado);
          tipoEtapas = tipoEtapas.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          });

          let tipoEtapa = tipoEtapas.find((e) => e.tipo === response.estado);
          let tipoGrupo = grupoEtapas.find((e) => e.id === response.gp_estado);

          setGrupo(tipoGrupo);
          setTipo(tipoEtapa);
        }
        setDefaultValues(response);
        setCurrentValues(response);
        setInmuebles(response.contribuyente_inmuebles);
        dispatch(setLoading(false));
      }
      else {
        setDefaultValues("");
        setCurrentValues("");
        dispatch(setLoading(false));
      }
    }
    catch (err) {
      setDefaultValues("");
      setCurrentValues("");
      dispatch(setLoading(false));
    }
  }

  const onSubmit = (newData) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        newData.inmuebles = inmuebles.filter(e => !e.id);
        newData.gp_estado = grupo ? grupo.id : "";
        
        dispatch(setLoading(true));

        let response = await misContribuyenteService.saveContribuyente(newData);

        dispatch(setLoading(false));
        
        if (response.ok) {
          let res = await misContribuyenteService.getContribuyente(contribuyente.id);

          reload();
          setDefaultValues(res);
          setCurrentValues(res);
          setInmuebles(res.contribuyente_inmuebles);

          return Swal.fire({
            title: "Exito!",
            text: "Los datos es guardaron correctamente.",
            icon: "success",
            willClose: () => handleClose()
          });
        }
        else {
          return Swal.fire(
            "Error!",
            "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };


  const handleChange = (e) => {
    setCurrentValues({
      ...currentValues,
      [e.target.name]: e.target.value
    });
  };

  const handleOpenInmueble = () => {
    setShowAddInmueble(true);
  };

  const handleCloseInmueble = () => {
    setShowAddInmueble(false);
  };

  const handleOpenEdit = () => {
    setShowEditInmueble(true);
  };

  const handleCloseEdit = () => {
    setShowEditInmueble(false);
  };


  const handleCancel = ({ inmueble }) => {
    setInmuebles(prev => {
      return prev.filter((e) => e.inmueble !== inmueble);
    });
  };

  const handleEdit = (e, index) => {
    setInmueble({
      ...e,
      index
    });

    handleOpenEdit();
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "¿Esta seguro de eliminar este inmueble?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let response = await misContribuyenteService.deleteInmueble(id);

        if (response.ok) {
          getData();

          return Swal.fire(
            "Exito!",
            "Los datos es guardaron correctamente.",
            "success"
          );
        }
        else {
          return Swal.fire(
            "Error!",
            "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };

  const handleClick = async (imponible) => {
    try {
      dispatch(setLoading(true));

      dispatch(getInmuebles({ inmueble: imponible }))
        .then(() => {
          dispatch(setLoading(false));
          handleClose();
          return history.push("inmuebles");
        })
        .catch(err => {
          console.log(err);
        });
    }
    catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };

  const handleSelect = (e) => {
    if (e) {
      setTipo("");
      setGrupo(e);
    }
    else {
      setGrupo("");
    }
  };

  const columns = [
    {
      title: "INMUEBLE",
      dataIndex: "inmueble",
      render: (_, row) => <div onClick={() => handleClick(row.inmueble)} className="link-custom" >{row.inmueble}</div>,
    },
    {
      title: "RECURSO",
      dataIndex: "recurso",
      key: "recurso",
    },
    {
      title: "OBSERVACIÓN",
      dataIndex: "observaciones",
      key: "observaciones",
    },
    {
      title: "ACCIONES",
      dataIndex: "accion",
      render: (_, row, index) => <div className="d-flex">
        <div>
          {row.id ? (
            <Button
              className="d-flex align-items-center ml-2"
              variant="contained"
              onClick={() => handleDelete(row.id)}
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Button>
          ) : (
            <Button
              className="d-flex align-items-center ml-2"
              variant="contained"
              onClick={() => handleCancel(row)}
            >
              <CloseOutlined style={{ color: "red" }} />
            </Button>
          )}
        </div>
        <div>
          <Button
            className="d-flex align-items-center ml-2"
            variant="contained"
            onClick={() => handleEdit(row, index)}
          >
            <EditOutlined />
          </Button>
        </div>
      </div>
    },
  ];

  const formatData = (dataTable) => {
    try {
      if (dataTable && dataTable?.length) {

        return dataTable.map((e) => {
          return {
            uuid: uuidv4(),
            ...e
          };
        });
      } else {
        return [];
      }
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  return (
    <Modal
      animation={false}
      show={!loading && show}
      onHide={handleClose}
      size="xl"
      className="contribuyente-modal"
      backdrop="static"
    >
      <Modal.Header closeButton />
      <Modal.Body>

        <Form className="contribuyente-form" onSubmit={handleSubmit(onSubmit)}>
          <Row style={{ marginBottom: 50 }}>
            <Col sm={12} md={6}>
              <div className="contribuyente-title">
                <img src={icon} alt="contribuyente" />
                <span>Datos del Contribuyente</span>
              </div>
            </Col>
            <Col sm={12} md={6} className="d-flex justify-content-end align-items-center" >
              <div className="d-flex justify-content-end align-items-center mr-2">
                <div className="editar-label">
                  <span className="mr-1">Editar</span>
                  <DoubleRightOutlined />
                </div>
                <Switch
                  onChange={() => {
                    setEdit(!edit);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Nombre
              </Form.Label>
              <Form.Control
                name="apynom"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.apynom !== defaultValues?.apynom}
                {...register("apynom")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>DNI</Form.Label>
              <Form.Control
                name="dni"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.dni !== defaultValues?.dni}
                {...register("dni")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>CUIT</Form.Label>
              <Form.Control
                name="cuit"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.cuit !== defaultValues?.cuit}
                {...register("cuit")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>CUIM</Form.Label>
              <Form.Control
                name="cuim"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.cuim !== defaultValues?.cuim}
                {...register("cuim")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={4} >
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Estado</Form.Label>
              <Controller
                name="gp_estado"
                control={control}
                render={({ field: { onChange } }) => {
                  return (
                    <Select
                      options={grupos?.length ? [emptyOption, ...grupos] : [emptyOption]}
                      value={grupo}
                      onChange={(e) => {
                        handleSelect(e);
                        return onChange(e?.value);
                      }}
                      disabled={!edit}
                    />
                  );
                }}
              />
            </Col>
            {grupo?.value ? (
              <Col sm={12} md={4} >
                <Form.Label className="mb-2" style={{ margin: 11.5, marginTop: 21.5 }}></Form.Label>
                <Controller
                  name="estado"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <Select
                        options={tipos?.length ? [emptyOption, ...tipos] : [emptyOption]}
                        value={tipo}
                        onChange={(e) => {
                          setTipo(e);
                          return onChange(e?.value);
                        }}
                        styles={errors.estado ? selectErrorStyles : selectStyles}
                        disabled={!edit}
                      />
                    );
                  }}
                />
                {errors.estado ? (
                  <div
                    className="invalid"
                    style={{
                      fontSize: "80%",
                      color: "#dc3545",
                      marginTop: 4
                    }}
                  >
                    {errors.estado.message}
                  </div>
                ) : ""}
              </Col>
            ) : ""}
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Calle</Form.Label>
              <Form.Control
                name="calle"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.calle !== defaultValues?.calle}
                {...register("calle")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Número</Form.Label>
              <Form.Control
                name="nro"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.nro !== defaultValues?.nro}
                {...register("nro")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Teléfono</Form.Label>
              <Form.Control
                name="telefono"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.telefono !== defaultValues?.telefono}
                {...register("telefono")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Email</Form.Label>
              <Form.Control
                name="email"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.email !== defaultValues?.email}
                {...register("email")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Titulo(titular, poseedor, tenedor, responsables)</Form.Label>
              <Form.Control
                name="titulo"
                plaintext={!edit}
                readOnly={!edit}
                isValid={currentValues?.titulo !== defaultValues?.titulo}
                {...register("titulo")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-3" style={{ marginTop: 10 }}>Inmuebles</Form.Label>
              <br />
              <Button
                onClick={handleOpenInmueble}
              >
                Agregar Inmueble
              </Button>
            </Col>
          </Row>

          <br />

          <Row className="pb-2">
            <Col sm={12} md={12}>
              <div className="section-table d-flex justify-content-center" style={{ overflow: "auto" }}>
                <Tabla
                  dataList={formatData(inmuebles)}
                  columns={columns}
                  expandable={true}
                  selection={false}
                  RowData={ModalRowData}
                />
              </div>
            </Col>
          </Row>

          <br />

          <Row className="justify-content-end">
            <Col style={{ maxWidth: 190 }}>
              <Button
                type="submit"
                className="custom-button"
              >
                <span className="ml-2">Guardar</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 140 }}>
              <Button
                className="danger-button ml-2"
                variant="danger"
                onClick={handleClose}
              >
                <span className="ml-2">Cancelar</span>
              </Button>
            </Col>
          </Row>
        </Form>

      </Modal.Body>
      {showAddInmueble ? (
        <AgregarInmueble show={showAddInmueble} handleClose={handleCloseInmueble} setInmuebles={setInmuebles} />
      ) : false}
      {showEditInmueble ? (
        <EditarInmueble show={showEditInmueble} handleClose={handleCloseEdit} getData={getData} setInmueble={setInmueble} setInmuebles={setInmuebles} inmueble={inmueble} inmuebles={inmuebles} />
      ) : false}
    </Modal>
  );
};


const mapDispatchToProps = (dispatch) => {
  return {
    editContribuyente: (id) => dispatch(editContribuyente(id)),
  };
};

export default connect(null, mapDispatchToProps)(EditContribuyente);
